module.exports = __webpack_public_path__ + "static/media/visa.b2689274.svg";